export default __webpack_public_path__ + "static/media/BOProto3.ad576a71.png";